import {BrandServiceName} from "../utils/names/serviceNames";
import {BrandService} from "./service/BrandService";
import {BrandServiceModuleConfig} from "./BrandServiceModuleConfiguration";


BrandServiceModuleConfig
    .createNewModule()
    .service(BrandServiceName, BrandService.instance);

